var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#deefee"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 10.375H11.2917C10.5093 10.375 9.875 11.0093 9.875 11.7917V18.1667C9.875 18.9491 10.5093 19.5833 11.2917 19.5833H17.6667C18.4491 19.5833 19.0833 18.9491 19.0833 18.1667V11.7917C19.0833 11.0093 18.4491 10.375 17.6667 10.375Z",
    stroke: "#00685F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04199 14.6253H6.33366C5.95794 14.6253 5.5976 14.4761 5.33192 14.2104C5.06625 13.9447 4.91699 13.5844 4.91699 13.2087V6.83366C4.91699 6.45794 5.06625 6.0976 5.33192 5.83192C5.5976 5.56625 5.95794 5.41699 6.33366 5.41699H12.7087C13.0844 5.41699 13.4447 5.56625 13.7104 5.83192C13.9761 6.0976 14.1253 6.45794 14.1253 6.83366V7.54199",
    stroke: "#00685F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/Clone.c6e8203947f120e05f826ae70d612fc9.svg";
export { ForwardRef as ReactComponent };